// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const facilitiesColorsForColObject = {
    preferredProviderIndicatorCalculated: { 0: 'yellow', 1: 'green', '-1': 'red' },
    signedContractFile: { y: 'green', n: 'red' }
};
